<template>
    <div class="filterbar-analytics-num-practice-mode">
        <button
            v-for="filtertag in filtertags" :key="filtertag.id"
            class="filterbar-analytics-num-practice-mode__filtertag"
            :class="selectionClass(filtertag)"
            @click="selectFiltertag(filtertag)">
            <span class="filterbar-analytics-num-practice-mode__filtertag-text">{{ filtertag.text }}</span>
        </button>
    </div>
</template>
<script>
    export default {
        computed: {
            filtertags(){
                return this.$store.state.filtertags.analyticsPractice.numPracticeMode;
            }
        },

        methods: {
            selectionClass(filtertag){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                return selectedFiltertagType === filtertag.type
                       ? 'filterbar-analytics-num-practice-mode--selected-filtertag'
                       : '';
            },

            selectFiltertag(filtertag){
                this.$store.commit('setSelectedFiltertag', {
                    categoryLabel: 'analyticsPractice',
                    filtertagLabel: 'numPracticeMode',
                    filtertag: filtertag
                });
                this.$store.state.sfx.filterbarClick.currentTime = 0;
                this.$store.state.sfx.filterbarClick.play();
            }
        }
    };
</script>
<style scoped src="@/css/components/filterbar-analytics-num-practice-mode.css"></style>